//웹앱개편 3차 신규 교재 카드 컴포넌트

import classNames from 'classnames'
import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import React from 'react'
import { useBasicPopup } from '../../components/basic/popup/BasicPopup'
import Badge from '../../components/common/Badge'
import { getEventUserType, GTM_CLICK_EVENT, sendGTMCustomClickEvent } from '../../helpers/gtmHelper'
import { useCurrentUser } from '../../modules/context/UserContext'
import { useOpenMaterialPopup } from '../../modules/hooks/common/useOpenMaterialPopup'
import { s_lesson_edit } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../modules/ids/e2e/student'
import { STUDENT_BTN_ID } from '../../modules/ids/gtm/student'
import { ICON_HEART_ACTIVE, ICON_HEART_INACTIVE } from '../../modules/svg/svg'
import { urlWidth } from '../../modules/utils'
interface PacketCardNewType {
  item
  className?
  onClickHeart?
  landing?
  onClickSelect?
  clickable?
  selected?
  imgLayout?
  qaId?
  isMobile?: boolean
}

const PacketCardNew: React.FC<PacketCardNewType> = ({
  item,
  className,
  onClickHeart,
  landing,
  onClickSelect,
  clickable,
  selected,
  imgLayout,
  qaId,
  isMobile = false,
}) => {
  const { title, subtitle, is_mine, category, image_url, id, is_revised, level, grade, is_today, course_type } = item
  const basicPopup = useBasicPopup()
  const router = useRouter()
  const showMaterialPopup = useOpenMaterialPopup()

  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  const handleClick = async (e) => {
    sendGTMCustomClickEvent(
      GTM_CLICK_EVENT.CLICK_SEE_MATERIAL_DETAIL,
      STUDENT_BTN_ID.CLICK_SEE_MATERIAL_DETAIL,
      'Material Card Detail',
      getEventUserType(currentUser),
      null, // 공통 컴포넌트이기에 자동 산출로 null 값 설정
      router.asPath,
      {
        material_name: title,
        material_category: category,
        is_bookmarked: is_mine,
      }
    )

    showMaterialPopup(e, id)
  }

  const handleOnClickSelect = (e) => {
    sendGTMCustomClickEvent(
      GTM_CLICK_EVENT.CLICK_SELECT_MATERIAL,
      STUDENT_BTN_ID.CLICK_SELECT_MATERIAL,
      'Material Card Detail',
      getEventUserType(currentUser),
      null, // 공통 컴포넌트이기에 자동 산출로 null 값 설정
      router.asPath,
      {
        material_name: title,
        material_category: category,
        is_bookmarked: is_mine,
      }
    )

    onClickSelect(e)
  }

  const handleOnClickHeart = (e) => {
    sendGTMCustomClickEvent(
      GTM_CLICK_EVENT.CLICK_BOOKMARK_MATERIAL,
      STUDENT_BTN_ID.CLICK_BOOKMARK_MATERIAL,
      'Material Card Heart',
      getEventUserType(currentUser),
      null, // 공통 컴포넌트이기에 자동 산출로 null 값 설정
      router.asPath,
      {
        material_name: title,
        material_category: category,
      }
    )

    onClickHeart(e)
  }

  return (
    <div className="relative">
      <div
        onClick={clickable ? (e) => handleClick(e) : undefined}
        className={classNames(
          [
            className,
            { 'hover:bg-gray-100': clickable },
            { 'cursor-pointer': clickable != false },
            { 'border-1 border-gray-100': !selected },
            { 'border-2 border-purple-500': selected },
          ],
          'relative mb-[6px] h-[330px] overflow-hidden rounded-[10px] bg-white shadow-sm'
        )}
      >
        <div className="block-copy-container h-[185px] overflow-hidden bg-gray-200">
          {image_url && image_url != '' && (
            <Image
              loading="lazy"
              className="object-cover"
              layout="fill"
              placeholder="empty"
              src={image_url ? urlWidth(image_url, 250) : ''}
              alt={title}
              unoptimized={true}
            />
          )}
        </div>
        {!landing && is_revised && (
          <Badge warning clx="absolute top-16 left-16">
            Revised
          </Badge>
        )}
        {!landing && is_today && (
          <Badge danger clx="absolute top-16 left-16">
            Today
          </Badge>
        )}
        {!onClickHeart || landing || (
          <div
            onClick={onClickHeart ? handleOnClickHeart : null}
            className="absolute top-[0px] right-[0px] m-[8px] p-[8px]"
          >
            {is_mine ? <img src={ICON_HEART_ACTIVE} /> : <img src={ICON_HEART_INACTIVE} />}
          </div>
        )}
        <div className="truncate-2-lines h-[130px] p-12 text-left">
          <div className="text-11 mb-[4px] leading-[16px] text-gray-500">{category}</div>
          <div className=" truncate-2-lines mb-[4px] break-keep text-[14px] font-medium text-black">{title}</div>
          {subtitle && <div className=" truncate break-keep text-[14px] text-gray-700">{subtitle}</div>}
        </div>
      </div>
      {onClickSelect && (
        <div
          data-ref={DATA_REF_KEY.btn_select_material}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            handleOnClickSelect(e)
          }}
          className={classNames(
            [{ 'hover:bg-purple-50': !selected }],
            'absolute bottom-[0px] right-[0px] mx-[8px] my-[5px] cursor-pointer rounded-[5px] p-[8px]'
          )}
        >
          <div className="text-h5 text-purple-500">
            {selected ? t(s_lesson_edit.cancel_material) : t(s_lesson_edit.select_material)}
          </div>
        </div>
      )}
    </div>
  )
}

export const MobilePacketCardNew: React.FC<PacketCardNewType> = ({
  item,
  className,
  onClickHeart,
  landing,
  onClickSelect,
  clickable,
  selected,
  isMobile = false,
}) => {
  const { title, subtitle, is_mine, category, image_url, id, is_revised, level, is_today, grade, course_type } = item
  const basicPopup = useBasicPopup()
  const { t } = useTranslation()
  const showMaterialPopup = useOpenMaterialPopup()
  return (
    <div className="relative">
      <div
        onClick={clickable ? (e) => showMaterialPopup(e, id, isMobile) : undefined}
        className={classNames(
          [
            className,
            { 'hover:bg-gray-100': clickable },
            { 'border-1 border-gray-100': !selected },
            { 'border-2 border-purple-500': selected },
          ],
          'relative mb-[6px] h-[210px] cursor-pointer overflow-hidden rounded-[10px] bg-white shadow-sm'
        )}
      >
        <div className="relative h-[120px] overflow-hidden bg-gray-200">
          {image_url && image_url != '' && (
            <img src={image_url ? urlWidth(image_url, 250) : ''} alt={title} className="h-full w-full object-cover" />
          )}
        </div>
        {!landing && is_revised && (
          <Badge warning clx="absolute top-16 left-16">
            Revised
          </Badge>
        )}
        {!landing && is_today && (
          <Badge danger clx="absolute top-16 left-16">
            Today
          </Badge>
        )}
        {!onClickHeart || landing || (
          <div onClick={onClickHeart ? onClickHeart : null} className="absolute top-[0px] right-[0px] m-[8px] p-[8px]">
            {is_mine ? <img src={ICON_HEART_ACTIVE} /> : <img src={ICON_HEART_INACTIVE} />}
          </div>
        )}
        <div className="px-[12px] pb-[12px] pt-[4px]">
          <div className="leading-tighter text-11 mb-[8px] text-gray-500">{category}</div>
          <div style={{ wordBreak: 'keep-all' }} className="truncate-2-lines mb-[8px] text-[14px] text-black">
            {title}
          </div>
        </div>
      </div>
      {onClickSelect && (
        <div
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onClickSelect(item.id)
          }}
          className={classNames(
            [{ 'hover:bg-purple-50': !selected }],
            'absolute bottom-[0px] right-[0px] mx-[8px] my-[5px] cursor-pointer rounded-[5px] p-[8px]'
          )}
        >
          <div className="text-h5 text-purple-500">
            {selected ? t(s_lesson_edit.cancel_material) : t(s_lesson_edit.select_material)}
          </div>
        </div>
      )}
    </div>
  )
}

export default PacketCardNew
